module.exports = __webpack_public_path__ + "img/slika-10.fa652066.png";